import { StateContext } from "@ngxs/store";

import { IStateProcessor } from "../state-processor";
import { AppDataStateModel } from "@shared/models/app-data.model";
import { NgxsStoreHelpers } from "@shared/stores/store.helpers";
import { CommonSearchCriteria } from "@shared/models/common-data.model";
import { DefaultKpiEconomy } from "@app/shared/models/kpi-economy.model";

export class EconomyStateProcessor implements IStateProcessor {
  GetDefaultSearchCriteria() {
    return DefaultKpiEconomy.search.searchForm.model.searchCriteria;
  }

  SetSearchCriteria(ctx: StateContext<AppDataStateModel>, searchCriteria: CommonSearchCriteria[]) {
    NgxsStoreHelpers.SetKpiEconomySearchCriteria(ctx, searchCriteria);
  }

  AttachSearchCriteriaIntoCurrent(ctx: StateContext<AppDataStateModel>, newSearchCriteria: CommonSearchCriteria[]) {
    var currentSearchCriteria = ctx.getState().kpiEconomy.search.searchForm.model.searchCriteria;
    this.SetSearchCriteria(ctx, [...newSearchCriteria, ...currentSearchCriteria]);
  }
}
